import { enumZoneStatus, ZoneStatus } from '@rematter/frontend-lib-api-client';
import { Badge } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

type ZoneStatusBadgeProps = {
  status: ZoneStatus;
};

const STATUS_BADGE_COLOR: Record<
  ZoneStatus,
  'neutral' | 'success' | 'warning' | 'failure'
> = {
  [enumZoneStatus.Active]: 'success',
  [enumZoneStatus.Closed]: 'warning',
  [enumZoneStatus.Archived]: 'neutral',
};

export const ZoneStatusBadge = ({ status }: ZoneStatusBadgeProps) => {
  const t = useTranslations();

  return (
    <Badge color={STATUS_BADGE_COLOR[status]} className="@ZoneStatusBadge">
      {t.zonesListView.statusTypes[status]}
    </Badge>
  );
};
